import { useState, useCallback } from "react";

export const useTableQueryParams = (initialState = {}) => {
  const [queryParams, setQueryParams] = useState({
    currentPage: 1,
    customPageSize: 5,
    searchValue: "",
    sortOrder: "desc",
    columnName: "id",
    ...initialState,
  });

  const handleSearchChange = useCallback((searchValue) => {
    setQueryParams((prev) => ({
      ...prev,
      searchValue,
      currentPage: 1,
    }));
  }, []);

  const handlePageChange = useCallback((currentPage) => {
    setQueryParams((prev) => ({ ...prev, currentPage }));
  }, []);

  const handlePageSizeChange = useCallback((customPageSize) => {
    setQueryParams((prev) => ({
      ...prev,
      customPageSize,
      currentPage: 1,
    }));
  }, []);

  const handleSortChange = useCallback((currentPage, columnName, sortOrder) => {
    setQueryParams((prev) => ({
      ...prev,
      currentPage,
      columnName,
      sortOrder,
    }));
  }, []);

  const resetToFirstPage = useCallback(() => {
    setQueryParams((prev) => ({ ...prev, currentPage: 1 }));
  }, []);

  return {
    queryParams,
    setQueryParams,
    ...queryParams,
    handleSearchChange,
    handlePageChange,
    handlePageSizeChange,
    handleSortChange,
    resetToFirstPage,
  };
};
